import { FC, memo } from 'react';
import { Helmet } from 'react-helmet';
import { generateSEO, SeoTitles } from './seo.constants';

type SeoComponentProps = {
    title: SeoTitles;
    addInfo?: string;
};

export const SeoComponent: FC<SeoComponentProps> = memo(({ title, addInfo }) => {
    const seoData = generateSEO(title, addInfo);

    return (
        <Helmet>
            <meta charSet="utf-8" />
            <title>{seoData.title}</title>
            <meta name="description" content={seoData.description} />
        </Helmet>
    );
});
